<template>
  <div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Sort</label>
      </div>
      <div class="field-body">
        <div class="field is-narrow">
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="sort" @change="loadAgents">
                <option v-for="s in sorts" :value="s">{{s.name}} {{s.lorder}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Search</label>
      </div>
      <div class="field-body">
        <div class="field is-narrow">
          <div class="control">
            <input v-model="searchQuery" type="text" placeholder="Number" class="input" />
          </div>
        </div>
        <div class="field is-narrow">
          <div class="control">
            <a class="button" @click="loadAgents()">Search</a>
          </div>
        </div>
      </div>
    </div>

    <div class="field">
      <div class="control">
        <router-link class="button is-success" :to="{'name':'create-agent'}">Create agent</router-link>
      </div>
    </div>

    <table class="table is-fullwidth is-hoverable is-size-7">
      <thead>
        <tr>
          <th>#</th>
          <th>Login</th>
          <th>Last login</th>
          <th>Last acc.</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="agent in agents">
          <td>
            <span v-if="agent.isLocked" class="tag is-danger" :title="agent.lockoutEndDate | datetime">LOCKED</span>
            {{agent.number}}
          </td>
          <td>
            <router-link :to="{ name: 'agent', params: { clientId: clientId, agentId: agent.id } }">
              {{ agent.username }}
            </router-link>
          </td>
          <td>{{agent.lastLogin | datetime}}</td>
          <td>{{agent.lastAccess | datetime}}</td>
          <td>
            <a v-if="agent.isLocked" class="button is-small" @click="unlockAgent(agent)">Unlock</a>
            <a v-else class="button is-warning is-small" @click="lockAgent(agent)">Lock</a>
          </td>
        </tr>
      </tbody>
    </table>

    <pagination @change="loadAgents();" ref="pagination" />
  </div>
</template>
<script>
  import agentService from '../../../../services/agent.service'

  import pagination from '../../../common/pagination.vue'
  import description from '../../../common/description.vue'

  export default {
    name: 'agents-list',
    components: { pagination, description },
    data() {
      return {
        searchQuery: null,
        agents: [],
        sorts: [
          { field: "name", name: "Name", order: "Ascending", lorder: "asc." },
          { field: "name", name: "Name", order: "Descending", lorder: "desc." },
          { field: "ll", name: "Last login", order: "Ascending", lorder: "asc." },
          { field: "ll", name: "Last login", order: "Descending", lorder: "desc." },
          { field: "la", name: "Last access", order: "Ascending", lorder: "asc." },
          { field: "la", name: "Last access", order: "Descending", lorder: "desc." },
          { field: "_reg", name: "Registered", order: "Ascending", lorder: "asc." },
          { field: "_reg", name: "Registered", order: "Descending", lorder: "desc." }
        ],
        sort: null
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    watch: {
      async clientId() {
        await this.loadAgents();
      }
    },
    async mounted() {
      this.sort = this.sorts[5];
      await this.loadAgents();
    },
    methods: {
      async loadAgents() {
        const filter = {
          pageNumber: this.$refs.pagination.pageNumber,
          pageSize: this.$refs.pagination.pageSize,
          sortBy: this.$data.sort.field,
          sortOrder: this.$data.sort.order,
          searchQuery: this.searchQuery
        };
        const data = await agentService.getByClient(this.clientId, filter);
        this.agents = data.items;
        this.$refs.pagination.set(data.pageNumber, data.totalPages);
      },
      async lockAgent(agent) {
        if (confirm("Are you sure you want to lock agent " + agent.username + "?")) {
          await agentService.lock(agent.id);
          await this.loadAgents();
        }
      },
      async unlockAgent(agent) {
        if (confirm("Are you sure you want to unlock agent " + agent.username + "?")) {
          await agentService.unlock(agent.id);
          await this.loadAgents();
        }
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/agents/list.vue